import React from 'react'
import { Redirect } from 'react-router-dom'
import { ADMIN_ROUTES } from '../../../../constants'

function AlternativeInvestmentsLanding () {
  return <Redirect to={ADMIN_ROUTES.ALTERNATIVE_INVESTMENTS_BATCH_NEW} />
}

export default AlternativeInvestmentsLanding
